import { Collapse, Typography, Button, Image } from 'antd';
import { useNavigate } from 'react-router-dom';
import { RightOutlined } from '@ant-design/icons';
import { INSTALL_CHAT_GUIDE_STEPS } from './installChatGuideSteps';

const { Paragraph, Text } = Typography;

/**
 * Paso a paso de instalación autocontenido (sin iframe): ver
 * installChatGuideSteps.js para el porqué.
 */
const InstallGuideSteps = ({ onNavigateInternal }) => {
  const navigate = useNavigate();

  const goInternal = (path) => {
    onNavigateInternal?.();
    navigate(path);
  };

  const items = INSTALL_CHAT_GUIDE_STEPS.map((step, i) => ({
    key: String(i),
    label: `${i + 1} · ${step.title}`,
    children: (
      <div>
        {step.description && <Paragraph style={{ marginBottom: 8 }}>{step.description}</Paragraph>}

        {step.bullets && (
          <ul style={{ marginTop: 0, marginBottom: 8, paddingLeft: 20 }}>
            {step.bullets.map((b) => (
              <li key={b}><Text>{b}</Text></li>
            ))}
          </ul>
        )}

        {step.substeps && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            {step.substeps.map((s) => (
              <div key={s.label}>
                <Text strong style={{ display: 'block', marginBottom: 4 }}>{s.label}</Text>
                <Paragraph type="secondary" style={{ marginBottom: s.image ? 8 : 0 }}>{s.text}</Paragraph>
                {s.image && (
                  <Image
                    src={s.image}
                    alt={s.label}
                    style={{ maxWidth: '100%', borderRadius: 8, border: '1px solid #f0f0f0' }}
                  />
                )}
              </div>
            ))}
          </div>
        )}

        {step.image && !step.substeps && (
          <Image
            src={step.image}
            alt={step.title}
            style={{ maxWidth: '100%', borderRadius: 8, border: '1px solid #f0f0f0', marginBottom: 8 }}
          />
        )}

        {step.internalLink && (
          <Button
            type="primary"
            icon={<RightOutlined />}
            iconPosition="end"
            onClick={() => goInternal(step.internalLink.path)}
            style={{ marginTop: 4, marginBottom: 8 }}
          >
            {step.internalLink.label}
          </Button>
        )}

        {step.note && (
          <Paragraph type="secondary" style={{ fontSize: 12, marginTop: 8, marginBottom: 0 }}>
            {step.note}
          </Paragraph>
        )}
      </div>
    ),
  }));

  return (
    <Collapse
      items={items}
      defaultActiveKey={['0']}
      accordion
      style={{ width: '100%' }}
    />
  );
};

export default InstallGuideSteps;
